'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NoReturnsAvailable = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _class3, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactSlidedown = require('react-slidedown');

var _components = require('../../components');

var _Returns = require('./Returns.css');

var _Returns2 = _interopRequireDefault(_Returns);

var _EsgConfig = require('../../components/EsgConfig/EsgConfig');

var _EsgConfig2 = _interopRequireDefault(_EsgConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
MINI COMPONENTS
*/
var NoReturnsAvailable = exports.NoReturnsAvailable = (_dec = (0, _reactCssModules2.default)(_Returns2.default, { allowMultiple: false }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NoReturnsAvailable, _Component);

  function NoReturnsAvailable() {
    (0, _classCallCheck3.default)(this, NoReturnsAvailable);
    return (0, _possibleConstructorReturn3.default)(this, (NoReturnsAvailable.__proto__ || (0, _getPrototypeOf2.default)(NoReturnsAvailable)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoReturnsAvailable, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'no-returns-avail' },
        _react2.default.createElement(_components.LinkIcon, {
          nospace: true,
          faclass: 'fa-exclamation-triangle'
        }),
        '\xA0 Less than one year of returns available'
      );
    }
  }]);
  return NoReturnsAvailable;
}(_react.Component)) || _class);

/*
COMPONENT CONSTRUCTOR
*/

var Returns = (_dec2 = (0, _reactCssModules2.default)(_Returns2.default, { allowMultiple: true }), _dec2(_class2 = (_temp = _class3 = function (_Component2) {
  (0, _inherits3.default)(Returns, _Component2);

  function Returns(props) {
    (0, _classCallCheck3.default)(this, Returns);

    // could be 1/3/6/12 month horizons in the future
    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Returns.__proto__ || (0, _getPrototypeOf2.default)(Returns)).call(this, props));

    _initialiseProps.call(_this2);

    var timeHorizonOpts = {
      decade: [{
        value: 'trailing_return_y1',
        label: 'one year',
        shortLabel: '1-yr',
        numLabel: '1 year'
      }, {
        value: 'trailing_return_y3',
        label: 'three years',
        shortLabel: '3-yr',
        numLabel: '3 years'
      }, {
        value: 'trailing_return_y5',
        label: 'five years',
        shortLabel: '5-yr',
        numLabel: '5 years'
      }, {
        value: 'trailing_return_y10',
        label: '10 years',
        shortLabel: '10-yr',
        numLabel: '10 years'
      }]
    };

    var defaultTimeHorizons = timeHorizonOpts.decade;

    /* we want the oldest shareclass performance available to be the initial
       time horizon used for comparison. if there is no shareclass performance
       for a horizon, set it to disabled, we won't show a button for it. if
       shareclass has no performance for any horizon, leave oldest shareclass
       performance as null. */
    var oldestSharePerf = null;
    for (var i = 0; i < defaultTimeHorizons.length; i++) {
      if (props.shareClass[defaultTimeHorizons[i].value] === -1000.0) {
        props.shareClass[defaultTimeHorizons[i].value] = null;
      }
      if (props.shareClass[defaultTimeHorizons[i].value]) {
        oldestSharePerf = defaultTimeHorizons[i];
        defaultTimeHorizons[i].disabled = false;
      } else {
        defaultTimeHorizons[i].disabled = true;
      }
    }

    // all benchmarks in config, but only those w/ 10-yr returns
    var benchmarks = _config2.default.coreBenchmarks.concat(_config2.default.extendedBenchmarks);
    var benchmarksWithPerf = benchmarks.filter(function (b) {
      return b.trailing_return_y10 !== '';
    });

    // choose first benchmark based on shareclass suggested benchmark
    var suggested = props.shareClass.morningstar_primary_benchmark;
    var initBench = _this2.getInitBench(suggested, benchmarksWithPerf).pop();

    // morningstar clickthrough url
    var morningstarUrl = (props.shareClass.morningstar_url || _config2.default.links.morningstar) + '?CID=DIS_IND063';

    var ThisEsgConfig = (0, _cloneDeep2.default)(_EsgConfig2.default);

    // if the fund has a null footprint, and the site is Fossil Free Funds, we need to make a fix
    // remove the footprint item from the EsgConfig item
    // if (config.app.title === 'Fossil Free Funds' && this.props.shareClass.usd_relative_footprint === null) {
    //   delete ThisEsgConfig.esgOptions.footprint
    //   ThisEsgConfig.esgNamesLabels = ThisEsgConfig.esgNamesLabels.filter((item) => {
    //     return item.value !== 'footprint'
    //   })
    // }

    _this2.state = {
      ThisEsgConfig: ThisEsgConfig,
      // all the time horizons available for comparisons and buttons
      // [{ value: 'trailing_return_y1',
      //    label: 'one year',
      //    shortLabel: '1-yr' },
      //  ... ]
      returnsTimeHorizon: defaultTimeHorizons,
      // the active time horizon being used for comparison
      // { value: 'trailing_return_y10',
      //   label: '10 years',
      //   shortLabel: '10-yr' }
      activeTimeHorizon: oldestSharePerf || null,
      // all the benchmarks available for comparisons and dropdowns
      allBenchmarks: benchmarksWithPerf,
      // the active benchmark being used for comparison
      // { fund_legal_name: 'iShares Core S&P 500 ETF',
      //   name: 'IVV - iShares Core S&P 500 ETF',
      //   ... }
      benchmark: initBench,
      /* array of differences resulting from subtracting benchmark returns.
         for each time horizon from shareclass returns from the same
         horizon. */
      // [ -6.35, 0.30, ... ]
      returnDiffs: _this2.calcReturnDiffs(defaultTimeHorizons, props.shareClass, initBench),
      /* ESG-keyed object with the current differences between shareclass and
         active benchmark ESG values. For each ESG object, the bench value is
         subtracted from the shareclass value and saved. These ESG diffs are
         recalculated if the benchmark changes. */
      // { fossils: -1.32,
      //   ... }
      esgDiffs: _this2.calcEsgDiffs(initBench, ThisEsgConfig),
      /* the default ESG comparison at start will be fossil fuels. If this
         page is actually carbon footprint or clean200, this will change the
         initial ESG comparison to reflect that. Right now this is only used
         for the table in the slidedown, all other components show comparisons
         for all ESG options. Only the table has esgSelect, which updates
         state.esg. This may be too much overhead for a minor feature */
      // { id: 'fossils',
      //   fieldLabel: 'c2f5coogutweight',
      //   ... }
      esg: _this2.getInitEsg(initBench, ThisEsgConfig),
      // clickthrough url
      morningstarUrl: morningstarUrl,
      // loading flags
      benchLoading: false,
      timeHorizonLoading: false,
      // expandable flags
      showExpandable: false,
      // ms for loading icon to display when settings changed
      loadingTime: 333
    };
    return _this2;
  }
  /* ------------------------ */

  /*
  INITIALIZING HELPERS
  */

  /* ------------------------ */

  /*
  FORM CONTROL ON CHANGES
  */
  // onChange for benchmarkSelect


  // onChange for esgSelect

  /* ------------------------ */

  /*
  CALCULATION HELPERS
  calcReturnDiffs -> for each time horizon, difference between shareclass and
                     benchmark, returned as array
  calcEsgDiffs -> for each ESG option, difference between shareclass and
                  benchmark, returned as object
  */

  /* ------------------------ */

  /*
  RENDER HELPERS
  renderEsgFormat -> apply format function of active esg to supplied value
  renderBenchmarkSelect -> render dropdown menu for benchmarks w/ on change
  */

  /* ------------------------ */

  /*
  renderCardTable
  */

  /* ------------------------ */

  /*
  renderSlideDown
  */


  (0, _createClass3.default)(Returns, [{
    key: 'render',

    /* ------------------------ */

    value: function render() {
      var shareClass = this.props.shareClass;
      return _react2.default.createElement(
        'div',
        { styleName: 'returns-wrap' },
        this.renderCardTable(shareClass),
        this.renderSlideDown(shareClass)
      );
    }
  }]);
  return Returns;
}(_react.Component), _class3.propTypes = {
  shareClass: _react.PropTypes.object.isRequired,
  url: _react.PropTypes.string.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getInitBench = function (suggested, benchmarks) {
    switch (suggested) {
      case 'MSCI ACWI NR USD':
        return _this3.findBenchByLabel('ACWI - iShares MSCI ACWI ETF', benchmarks);
      case 'MSCI ACWI Ex USA NR USD':
        return _this3.findBenchByLabel('ACWX - iShares MSCI ACWI ex U.S. ETF', benchmarks);
      default:
        return _this3.findBenchByLabel('IVV - iShares Core S&P 500 ETF', benchmarks);
    }
  };

  this.getInitEsg = function (initBench, ThisEsgConfig) {
    var initEsg = null;
    (0, _keys2.default)(ThisEsgConfig.esgOptions).map(function (key) {
      initEsg = _this3.props.url.indexOf(ThisEsgConfig.esgOptions[key].page) >= 0 ? ThisEsgConfig.esgOptions[key] : initEsg;
      return true;
    });
    // default to first option in esgNamesLabels
    return initEsg || ThisEsgConfig.esgOptions[ThisEsgConfig.esgNamesLabels[0].value];
  };

  this.findBenchByLabel = function (label, benchmarks) {
    return benchmarks.filter(function (benchmark) {
      return label === benchmark.label;
    });
  };

  this.benchmarkOnChange = function (chosen) {
    // chosen = { value, label }
    var nextBenchmark = _this3.findBenchByLabel(chosen.label, _this3.state.allBenchmarks);

    if (nextBenchmark.length > 0) {
      var returnDiffs = _this3.calcReturnDiffs(_this3.state.returnsTimeHorizon, _this3.props.shareClass, nextBenchmark[0]);

      var esgDiffs = _this3.calcEsgDiffs(nextBenchmark[0]);

      _this3.setState({
        benchmark: nextBenchmark[0],
        returnDiffs: returnDiffs,
        esg: _this3.state.ThisEsgConfig.esgOptions[_this3.state.esg.id],
        esgDiffs: esgDiffs,
        benchLoading: true
      });

      // for loading icon
      setTimeout(function () {
        _this3.setState({
          benchLoading: false
        });
      }, _this3.state.loadingTime);
    }
  };

  this.esgOnChange = function (chosen) {
    // chosen = { value, label }
    // update state to select a new ESG comparison
    // default to first option in esgNamesLabels
    var selection = chosen || _this3.state.ThisEsgConfig.esgNamesLabels[0];
    var esg = _this3.state.ThisEsgConfig.esgOptions[selection.value];

    _this3.setState({
      esg: esg
    });
  };

  this.calcReturnDiffs = function (timeHorizons, share, bench) {
    return timeHorizons.map(function (timeHorizon) {
      var key = timeHorizon.value;
      return share[key] && bench[key] ? share[key] - bench[key] : null;
    });
  };

  this.calcEsgDiffs = function (bench) {
    var esgConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var newDiffs = {};
    var _esgConfig = esgConfig || _this3.state.ThisEsgConfig;
    (0, _keys2.default)(_esgConfig.esgOptions).map(function (key) {
      newDiffs[key] = _this3.props.shareClass[_esgConfig.esgOptions[key].fieldLabel] - bench[_esgConfig.esgOptions[key].benchLabel];
      return true;
    });
    return newDiffs;
  };

  this.renderEsgFormat = function (val) {
    var abs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    /* if we have an item and a selected ESG apply the correct format function
       to the relevant field */
    if ((val || val === 0) && _this3.state.esg && _this3.state.esg.format) {
      var absVal = abs ? Math.abs(val) : val;
      return _react2.default.createElement(
        'span',
        null,
        _this3.state.esg.format(absVal),
        '\xA0',
        _this3.state.esg.units
      );
    }
    return _react2.default.createElement(
      'span',
      null,
      ' / '
    );
  };

  this.renderBenchmarkSelect = function () {
    return _react2.default.createElement(
      'div',
      { styleName: 'benchmark-select-wrap' },
      _react2.default.createElement(_reactSelect2.default, {
        name: 'form-field-name',
        value: _this3.state.benchmark,
        onChange: _this3.benchmarkOnChange,
        options: _this3.state.allBenchmarks,
        clearable: false
      })
    );
  };

  this.renderCardTable = function (_shareClass) {
    var renderCardTableHeader = function renderCardTableHeader(shareClass) {
      var logo = require('../../../static/images/img-morningstar.png');
      var investment_vehicle_id = shareClass.investment_vehicle_id,
          ticker = shareClass.ticker;

      var url = _this3.state.morningstarUrl;
      return _react2.default.createElement(
        'div',
        { styleName: 'returns-container-headline-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'returns-container-headlines' },
          _react2.default.createElement(
            'div',
            { styleName: 'returns-container-headline' },
            'Financial performance'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'returns-container-subheading' },
            'Performance data provided by',
            _react2.default.createElement(
              _components.Link,
              {
                to: url,
                log: _analytics2.default.eventToMorningstar(investment_vehicle_id)
              },
              _react2.default.createElement('img', {
                src: logo,
                styleName: 'morningstar-logo-inline',
                alt: 'Morningstar'
              })
            ),
            'Find more financial data on ',
            ticker,
            ' at\xA0',
            _react2.default.createElement(
              _components.Link,
              {
                to: url,
                log: _analytics2.default.eventToMorningstar(investment_vehicle_id)
              },
              'Morningstar.com',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    };

    var renderFundCard = function renderFundCard(shareClass) {
      return _react2.default.createElement(
        'div',
        { styleName: 'fund-card-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'fund-card-fund' },
          _react2.default.createElement(
            'div',
            { styleName: 'fund-card-content-fund' },
            _react2.default.createElement(
              'div',
              { styleName: 'fund-card-ticker-top' },
              _react2.default.createElement(
                'span',
                { styleName: 'fund-card-ticker-span-top' },
                'Current fund'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'fund-card-name' },
              shareClass.ticker ? _react2.default.createElement(
                'div',
                { styleName: 'fund-card-name-ticker' },
                shareClass.ticker
              ) : null,
              _react2.default.createElement(
                'div',
                { styleName: 'fund-card-name-name' },
                shareClass.fund_legal_name
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'fund-card-type' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'fund-card-type-label' },
                  'Family'
                ),
                shareClass.fund_family_name
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'fund-card-type-label' },
                  'Category'
                ),
                shareClass.morningstar_category_name
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fund-card-footer-link' },
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.routes.clean,
              title: 'Find more funds | Search - ' + _config2.default.app.title
            },
            _react2.default.createElement(
              'span',
              { styleName: 'fund-card-footer-link-label' },
              'Find another fund',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    };

    var renderBenchmarkCard = function renderBenchmarkCard() {
      return _react2.default.createElement(
        'div',
        { styleName: 'fund-card-wrap' },
        _this3.state.benchLoading ? _react2.default.createElement(
          'div',
          { styleName: 'fund-card-loading' },
          _react2.default.createElement(
            'div',
            { styleName: 'fund-card-loader-offset' },
            _react2.default.createElement(_reactLoader2.default, {
              options: { scale: 0.70, top: '2.0rem' },
              loaded: false
            })
          )
        ) : _react2.default.createElement(
          'div',
          { styleName: 'fund-card-benchmark' },
          _react2.default.createElement(
            'div',
            { styleName: 'fund-card-content-benchmark' },
            _react2.default.createElement(
              'div',
              { styleName: 'fund-card-ticker-top' },
              _react2.default.createElement(
                'span',
                { styleName: 'fund-card-ticker-span-top b-ticker' },
                'Benchmark'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'fund-card-name' },
              _react2.default.createElement(
                'div',
                { styleName: 'fund-card-name-ticker' },
                _this3.state.benchmark.ticker
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'fund-card-name-name' },
                _this3.state.benchmark.fund_legal_name
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'fund-card-type' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'fund-card-type-label' },
                  'Family'
                ),
                'iShares from BlackRock'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'fund-card-type-label' },
                  'Category'
                ),
                _this3.state.benchmark.morningstar_category_name
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            styleName: 'fund-card-footer-link',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': "<div style='max-width:200px; font-size:12px;'>In the settings box, use the dropdown menu labeled 'Benchmark' to choose from a range of common benchmarks</div>",
            'data-for': 'benchmark-card-tooltip',
            'data-place': 'top',
            'data-html': true
          },
          'Change benchmark',
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' }),
          _react2.default.createElement(_reactTooltip2.default, { id: 'benchmark-card-tooltip' })
        )
      );
    };

    var renderTimeHorizonButtongroup = function renderTimeHorizonButtongroup() {
      // horizon = {
      //   value: 'trailing_return_y1',
      //   label: 'one year',
      //   shortLabel: '1-yr'
      // }
      if (_this3.state.activeTimeHorizon) {
        var isActive = function isActive(val) {
          return val === _this3.state.activeTimeHorizon.shortLabel ? 'active-btn' : '';
        };

        var _onClick = function _onClick(selectedTimehorizon) {
          var chosen = _this3.state.returnsTimeHorizon.filter(function (timehorizon) {
            return timehorizon.shortLabel === selectedTimehorizon;
          });
          if (chosen.length > 0) {
            var item = chosen.pop();
            if (item.shortLabel !== _this3.state.activeTimeHorizon.shortLabel) {
              _this3.setState({
                activeTimeHorizon: item,
                timeHorizonLoading: true
              });

              // for loading icon
              setTimeout(function () {
                _this3.setState({
                  timeHorizonLoading: false
                });
              }, _this3.state.loadingTime);
            }
          }
        };

        return _react2.default.createElement(
          'div',
          { styleName: 'annual-return-timeline-buttongroup' },
          _this3.state.returnsTimeHorizon.map(function (item) {
            return !item.disabled ? _react2.default.createElement(
              'div',
              {
                key: item.shortLabel,
                styleName: 'annual-return-timeline-button ' + isActive(item.shortLabel),
                onClick: function onClick() {
                  _onClick(item.shortLabel);
                }
              },
              _react2.default.createElement(
                'div',
                { styleName: 'annual-return-timeline-button-div' },
                item.numLabel
              )
            ) : _react2.default.createElement(
              'div',
              {
                key: item.shortLabel,
                styleName: 'annual-return-timeline-button-disabled'
              },
              _react2.default.createElement(
                'div',
                { styleName: 'annual-return-timeline-button-div' },
                item.numLabel
              )
            );
          })
        );
      } else {
        return _react2.default.createElement(NoReturnsAvailable, null);
      }
    };

    var renderSettingsCard = function renderSettingsCard(shareClass) {
      var benchName = null;
      switch (shareClass.morningstar_primary_benchmark) {
        case 'S&P 500 TR USD':
          benchName = 'S&P 500';
          break;
        case 'MSCI ACWI NR USD':
          benchName = 'MSCI ACWI';
          break;
        case 'MSCI ACWI Ex USA NR USD':
          benchName = 'MSCI ACWI Ex USA';
          break;
        default:
          benchName = 'Not available';
          break;
      }
      return _react2.default.createElement(
        'div',
        { styleName: 'form-controls' },
        _react2.default.createElement(
          'div',
          { styleName: 'form-control-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'fund-card-label' },
            'Fund comparison settings'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'form-control-label' },
            'Investment timeline',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-calendar' })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'em',
              null,
              'Performance as of:\xA0',
              (0, _moment2.default)(shareClass.performance_as_of_date).format('M/DD/YY')
            )
          ),
          renderTimeHorizonButtongroup()
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'w100 form-control-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'form-control-label' },
            'Benchmark',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-sliders' })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'em',
              null,
              'Suggested: ',
              benchName
            )
          ),
          _this3.renderBenchmarkSelect()
        )
      );
    };

    var renderResultsCardReturnsComparison = function renderResultsCardReturnsComparison(shareClass) {
      if (_this3.state.activeTimeHorizon) {
        var horizon = _this3.state.activeTimeHorizon;
        var share = shareClass[horizon.value] / 100.0;
        var bench = _this3.state.benchmark[horizon.value] / 100.0;
        var diff = share - bench;
        var higherLower = diff === 0 ? 'Same' : diff > 0 ? 'Higher' : 'Lower';
        var moreLess = diff === 0 ? 'Same' : diff > 0 ? 'More' : 'Less';

        var icon = diff === 0 ? 'right' : diff > 0 ? 'up' : 'down';
        var diffStyle = diff === 0 ? 'higher-lower' : diff > 0 ? 'higher-good' : 'lower-bad';
        // const iSrc = (diff === 0)
        //              ? require( '../../../static/images/icons_step1_gray.svg')
        //              : (diff > 0)
        //              ? require( '../../../static/images/icons_step1.svg')
        //              : require( '../../../static/images/icons_step1_red.svg')
        if (!isNaN(diff)) {
          return _react2.default.createElement(
            'div',
            { styleName: 'card-center' },
            _react2.default.createElement(
              'div',
              { styleName: 'comparison-arrow-wrap' },
              _react2.default.createElement(
                'span',
                { styleName: diffStyle },
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-2x fa-arrow-circle-' + icon })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'higher-lower' },
              _react2.default.createElement(
                'div',
                { styleName: diffStyle },
                higherLower
              ),
              '\xA0',
              horizon.shortLabel,
              ' returns\xA0',
              _react2.default.createElement(
                'div',
                { styleName: 'small-higher-lower' },
                _react2.default.createElement(
                  'span',
                  { styleName: diffStyle },
                  _format2.default.perc(diff),
                  '\xA0',
                  moreLess.toLowerCase(),
                  ' in annualized returns'
                )
              )
            )
          );
        }
        return _react2.default.createElement(
          'div',
          { styleName: 'card-center' },
          _react2.default.createElement(
            'span',
            null,
            ' #ERROR '
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { styleName: 'card-center' },
          _react2.default.createElement(NoReturnsAvailable, null)
        );
      }
    };

    var renderResultsCardESGComparisons = function renderResultsCardESGComparisons(shareClass) {
      return _react2.default.createElement(
        'div',
        null,
        // use EsgConfig.esgNamesLabels because it's in order
        _this3.state.ThisEsgConfig.esgNamesLabels.map(function (key, idx) {
          // this ESG object
          var thisEsg = _this3.state.ThisEsgConfig.esgOptions[key.value];
          // calc esg comparison
          var share = _convert2.default.float(shareClass[thisEsg.fieldLabel]);
          var bench = _convert2.default.float(_this3.state.benchmark[thisEsg.benchLabel]);
          var diff = share - bench;
          /* get ESG config fields */
          // diff formatted as number or percent
          var formatted = thisEsg.format(diff);
          // true if our diff is 'good', else false
          // const diffGood = thisEsg.diffGood(diff)
          //
          var label = thisEsg.label;
          var unitsExpanded = thisEsg.unitsExpanded;
          // use let for equal comparison styles (i.e. diff=0.0)
          var icon = diff > 0 ? 'up' : 'down';
          var diffStyle = thisEsg.diffStyle(diff);
          var moreLess = thisEsg.moreLess(diff);
          // let imgIcon = (diffGood)
          //               ? require('../../../static/images/'
          //                         + thisEsg.icon
          //                         + '.svg' )
          //               : require('../../../static/images/'
          //                         + thisEsg.icon
          //                         + '_red.svg' )
          // special styles for equal diff (i.e. equal comparison)
          if (diff === 0) {
            icon = 'right';
            diffStyle = 'higher-lower';
            moreLess = 'Same';
            // imgIcon = require('../../../static/images/'
            //                   + thisEsg.icon
            //                   + '_gray.svg')
          }

          // hack to trim negative from formatted number
          formatted = formatted.slice(0, 1) === '-' ? formatted.substring(1) : formatted;

          if (!isNaN(diff)) {
            return _react2.default.createElement(
              'div',
              { key: key.value, styleName: 'card-center' },
              _react2.default.createElement(
                'div',
                { styleName: 'comparison-arrow-wrap' },
                _react2.default.createElement(
                  'span',
                  { styleName: diffStyle },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-2x fa-arrow-circle-' + icon })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-lower' },
                _react2.default.createElement(
                  'span',
                  { styleName: diffStyle },
                  moreLess
                ),
                '\xA0',
                label,
                '\xA0',
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-higher-lower' },
                  _react2.default.createElement(
                    'span',
                    { styleName: diffStyle },
                    formatted,
                    unitsExpanded,
                    '\xA0',
                    moreLess === 'Same' ? null : moreLess.toLowerCase()
                  )
                )
              )
            );
          }
          return null;
        })
      );
    };

    var renderResultsCard = function renderResultsCard(shareClass) {
      return _react2.default.createElement(
        'div',
        {
          styleName: 'form-comparison-wrap',
          onClick: function onClick() {
            _this3.setState({
              showExpandable: !_this3.state.showExpandable
            });
          }
        },
        _react2.default.createElement(
          'div',
          { styleName: 'fund-card-label' },
          'Fund comparison results'
        ),
        _react2.default.createElement(
          'div',
          null,
          'Compared to the benchmark, this fund has:'
        ),
        _this3.state.benchLoading || _this3.state.timeHorizonLoading ? _react2.default.createElement(
          'div',
          { style: { position: 'relative', height: '200px' } },
          _react2.default.createElement(
            'div',
            { style: { position: 'relative' } },
            _react2.default.createElement(_reactLoader2.default, {
              options: { scale: 0.70, top: '2.0rem' },
              loaded: false
            })
          )
        ) : _react2.default.createElement(
          'div',
          null,
          renderResultsCardReturnsComparison(shareClass),
          renderResultsCardESGComparisons(shareClass)
        )
      );
    };

    /*
    Card table layout
    */
    return _react2.default.createElement(
      'div',
      { styleName: 'returns-container' },
      _react2.default.createElement(
        'div',
        { styleName: 'returns-container-inner' },
        _react2.default.createElement(
          'div',
          null,
          renderCardTableHeader(_shareClass),
          _react2.default.createElement(
            'div',
            { styleName: 'cards-row' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'visible-desktop' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                {
                  md: 8, lg: 8,
                  styleName: 'cards-center'
                },
                renderFundCard(_shareClass),
                _react2.default.createElement(
                  'div',
                  { styleName: 'vs-col' },
                  'vs.'
                ),
                renderBenchmarkCard()
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                {
                  md: 4, lg: 4,
                  styleName: 'cards-center-vert'
                },
                renderSettingsCard(_shareClass),
                renderResultsCard(_shareClass)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'visible-tablet' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    sm: 12,
                    styleName: 'cards-center'
                  },
                  renderFundCard(_shareClass),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'vs-col' },
                    'vs.'
                  ),
                  renderBenchmarkCard()
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    sm: 6,
                    styleName: 'cards-center-vert'
                  },
                  renderSettingsCard(_shareClass)
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    sm: 6,
                    styleName: 'cards-center-vert'
                  },
                  renderResultsCard(_shareClass)
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'visible-mobile' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    xs: 12,
                    styleName: 'cards-center'
                  },
                  renderFundCard(_shareClass),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'mobile-vs-col' },
                    'vs.'
                  ),
                  renderBenchmarkCard()
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    xs: 12,
                    styleName: 'cards-center-vert'
                  },
                  renderSettingsCard(_shareClass),
                  renderResultsCard(_shareClass)
                )
              )
            )
          )
        )
      )
    );
  };

  this.renderSlideDown = function (_shareClass) {
    /*
    Bullet points
    */
    // const slideDownText = (shareClass) => {
    //   if (this.state.activeTimeHorizon) {
    //     return (
    //       <div styleName='h3'>
    //         If you invested in <strong>{shareClass.ticker || shareClass.fund_legal_name}</strong> { this.state.activeTimeHorizon.label } ago, compared to the benchmark <strong>{this.state.benchmark.ticker}</strong> you would have:
    //       </div>
    //     )
    //   } else {
    //     return (
    //       <div styleName='h3'>
    //         If you invested in <strong>{shareClass.ticker || shareClass.fund_legal_name}</strong>, compared to the benchmark <strong>{this.state.benchmark.ticker}</strong> you would have:
    //       </div>
    //     )
    //   }
    // }

    // const renderSlideDownReturnsBulletValue = (diff, moreLess, style) => {
    //   return (!isNaN(diff))
    //          ? (diff === 0)
    //          ? (<span><strong>the same amount</strong></span>) // diff = 0.0
    //          : (<span styleName={style}>
    //               {format.perc(Math.abs(diff))} {moreLess}
    //            </span>)                                        // diff = +/- %
    //          : (<span>#ERROR</span>)                           // diff = ???
    // }

    // const renderSlideDownReturnsBullet = (shareClass) => {
    //   let shareVal = null
    //   let benchVal = null
    //   let diff = null
    //   let moreLess = null
    //   let diffStyle = null
    //   let icon = null
    //   const horizon = this.state.activeTimeHorizon
    //   if (horizon && shareClass[horizon.value] !== '') {
    //     shareVal = shareClass[horizon.value] / 100.0
    //     benchVal = this.state.benchmark[horizon.value] / 100.0
    //     diff = shareVal - benchVal
    //     moreLess = (diff > 0)
    //                ? 'more'
    //                : 'less'
    //     diffStyle = (diff > 0)
    //                 ? 'positive'
    //                 : 'negative'
    //     icon = (diff === 0)
    //            ? require( '../../../static/images/icons_step1_gray.svg')
    //            : (diffStyle === 'positive')
    //            ? require( '../../../static/images/icons_step1.svg')
    //            : require( '../../../static/images/icons_step1_red.svg')
    //   }
    //   return (
    //     <div styleName='comparison-li'>
    //       { (icon) ? (<img
    //         src={icon}
    //         alt={'Returns'}
    //         styleName='comparison-li-icon'
    //       />) : null }
    //       { (this.state.activeTimeHorizon) ? (
    //           <div styleName='comparison-li-text'>
    //             made an average of
    //             &nbsp;
    //             <strong>
    //               { renderSlideDownReturnsBulletValue(diff,
    //                                                   moreLess,
    //                                                   diffStyle) }
    //             </strong>
    //             &nbsp;
    //             in annualized returns
    //           </div>
    //         ) : (
    //           <div styleName='comparison-li-text'>
    //             <NoReturnsAvailable />
    //           </div>
    //         ) }
    //     </div>
    //   )
    // }

    // const renderSlideDownEsgBullets = (shareClass) => {
    //   // for each ESG type, format and render the difference from benchmark
    //   return EsgConfig.esgNamesLabels.map((key, idx)=>{
    //     const diff = this.state.esgDiffs[key.value]
    //     const thisEsg = EsgConfig.esgOptions[key.value]

    //     let diffDescriptor = thisEsg.moreLess(diff).toLowerCase()

    //     // for some ESG types higher is better, vice versa for others
    //     const dir = thisEsg.direction
    //     const compareDirection = (dir === 'ascending')
    //                              ? (diff < 0)
    //                              : (diff > 0)
    //     let compareStyle = (compareDirection)
    //                          ? 'positive'
    //                          : 'negative'

    //     // icons change color based on good or bad results
    //     let icon = (compareStyle === 'positive')
    //                ? require('../../../static/images/'
    //                          + thisEsg.icon
    //                          + '.svg')
    //                : require('../../../static/images/'
    //                          + thisEsg.icon
    //                          + '_red.svg')

    //     // if the diff is equal, it gets a special set of styles
    //     if (diff === 0) {
    //       diffDescriptor = 'the same'
    //       compareStyle = ''
    //       icon = require('../../../static/images/'
    //                      + thisEsg.icon
    //                      + '_gray.svg')
    //     }

    //     const ticker = (shareClass.ticker) ? shareClass.ticker : 'N'
    //     const name = format.sanitize(shareClass.fund_legal_name)
    //     const page = thisEsg.page

    //     let url = config.routes.fund + '/'
    //               + name + '/' + ticker + '/'
    //               + page + '/' + shareClass.fund_id + '/'
    //               + shareClass.investment_vehicle_id

    //     /* hide the link to each ESG options dedicated page if that page is
    //        the active page (e.g. if we're on fossil page, don't add link to
    //        fund's fossil page after fossil comparison) */
    //     const hide = this.props.url.indexOf(thisEsg.page) >= 0
    //     url = (hide) ? null : url

    //     return (
    //       <div styleName='comparison-li' key={idx}>
    //         <img
    //           src={icon}
    //           alt={thisEsg.valueLabel}
    //           styleName='comparison-li-icon'
    //         />
    //         <div styleName='comparison-li-text'>
    //           { thisEsg.formatExpanded(Math.abs(diff),
    //                                    diffDescriptor,
    //                                    compareStyle,
    //                                    url) }
    //         </div>
    //       </div>
    //     )
    //   })
    // }

    /*
    Returns table
    */
    var renderTableHeadlines = function renderTableHeadlines(shareClass) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'headline' },
          'Month-end trailing returns \xA0',
          _react2.default.createElement('i', {
            className: 'fa fa-info-circle',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': "<div style='max-width:300px; font-size:10px;'>Expressed in percentage terms, Morningstar's calculation of total return is determined each month by taking the change in monthly net asset value, reinvesting all income and capital-gains distributions during that month, and dividing by the starting NAV. Reinvestments are made using the actual reinvestment NAV, and daily payoffs are reinvested monthly. Unless otherwise noted, Morningstar does not adjust total returns for sales charges (such as front-end loads, deferred loads and redemption fees), preferring to give a clearer picture of a fund's performance. The total returns do account for management, administrative, 12b-1 fees and other costs taken out of fund assets. Total returns for periods longer than one year are expressed in terms of compounded average annual returns (also known as geometric total returns), affording a more meaningful picture of fund performance than non-annualized figures. Returns for periods longer than one year are expressed as annualized returns. This is equivalent to the compound rate of return which, over a certain period of time, would produce a fund's total return over that same period.</div>",
            'data-for': 'returns-headline-tooltip',
            'data-place': 'bottom',
            'data-html': true
          }),
          _react2.default.createElement(_reactTooltip2.default, { id: 'returns-headline-tooltip' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'dateline' },
          _react2.default.createElement(
            'strong',
            null,
            'Performance as of date:'
          ),
          '\xA0',
          (0, _moment2.default)(shareClass.performance_as_of_date).format('M/DD/YY')
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'dateline' },
          _react2.default.createElement(
            'strong',
            null,
            'Morningstar suggested benchmark:'
          ),
          '\xA0',
          shareClass.morningstar_primary_benchmark
        )
      );
    };

    var renderTableHeaderRow = function renderTableHeaderRow() {
      var renderEsgSelect = function renderEsgSelect() {
        var selectedEsg = _this3.state.esg ? {
          'label': _this3.state.esg.valueLabel,
          'value': _this3.state.esg.id
        } : null;

        return _react2.default.createElement(
          'div',
          { style: { width: '175px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'form-field-name',
            value: selectedEsg,
            onChange: _this3.esgOnChange,
            options: _this3.state.ThisEsgConfig.esgNamesLabels,
            clearable: false
          })
        );
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          { styleName: 'annual-return-top-row' },
          _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 5 }),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 4, styleName: 'col-center gray' },
            'Annualized returns'
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 3, styleName: 'col-center alt-color' },
            'Climate analysis'
          )
        ),
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          { styleName: 'annual-return-top-row' },
          _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 5 }),
          _this3.state.returnsTimeHorizon.map(function (timeHorizon, idx) {
            return _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { key: idx, xs: 1, styleName: 'col-center' },
              timeHorizon.shortLabel
            );
          }),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 3, styleName: 'col-center' },
            _this3.state.ThisEsgConfig.esgNamesLabels.length > 1 ? renderEsgSelect() : _this3.state.esg.valueLabel
          )
        )
      );
    };

    var renderTableReturnValue = function renderTableReturnValue(returnVal) {
      return returnVal ? _react2.default.createElement(
        'span',
        null,
        _format2.default.perc(returnVal / 100.0)
      ) : _react2.default.createElement(
        'span',
        { styleName: 'neutral' },
        '/'
      );
    };

    var renderTableShareclassRow = function renderTableShareclassRow(shareClass) {
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'annual-return-bottom-row' },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 5 },
          _react2.default.createElement(
            'strong',
            null,
            'This fund'
          ),
          _react2.default.createElement('br', null),
          shareClass.ticker,
          ' - ',
          shareClass.fund_legal_name
        ),
        _this3.state.returnsTimeHorizon.map(function (key, idx) {
          return _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { key: idx, xs: 1, styleName: 'col-center' },
            renderTableReturnValue(shareClass[key.value])
          );
        }),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 3, styleName: 'col-center' },
          _this3.renderEsgFormat(shareClass[_this3.state.esg.fieldLabel])
        )
      );
    };

    var renderTableBenchmarkRow = function renderTableBenchmarkRow() {
      var benchEsg = _this3.state.benchmark[_this3.state.esg.benchLabel];
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'annual-return-bottom-row' },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 5 },
          _react2.default.createElement(
            'strong',
            null,
            'Benchmark'
          ),
          _react2.default.createElement('br', null),
          _this3.renderBenchmarkSelect()
        ),
        _this3.state.returnsTimeHorizon.map(function (key, idx) {
          return _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { key: idx, xs: 1, styleName: 'col-center' },
            renderTableReturnValue(_this3.state.benchmark[key.value])
          );
        }),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 3, styleName: 'col-center' },
          _this3.renderEsgFormat(benchEsg)
        )
      );
    };

    var renderTableComparisonRow = function renderTableComparisonRow() {
      var renderReturnComparison = function renderReturnComparison(val) {
        // if diff is equal (0.0) or doesn't exist, return defaults
        if (val === 0.0) {
          return _react2.default.createElement(
            'span',
            null,
            '+0%'
          );
        } else if (!val) {
          return _react2.default.createElement(
            'span',
            { styleName: 'neutral' },
            '/'
          );
        }

        // if we have a diff, find positive or negative
        var diffStyle = val > 0 ? 'positive' : 'negative';

        var diffFa = val > 0 ? 'fa-arrow-up' : 'fa-arrow-down';

        return _react2.default.createElement(
          'span',
          { styleName: diffStyle },
          _format2.default.perc(val / 100.0),
          _react2.default.createElement(_components.LinkIcon, { faclass: diffFa })
        );
      };

      var renderTableEsgComparison = function renderTableEsgComparison() {
        // render comparison for the active ESG
        var diff = _this3.state.esgDiffs[_this3.state.esg.id];

        // if diff is equal (0.0), return default
        if (diff === 0.0) {
          return _react2.default.createElement(
            'span',
            null,
            'Same'
          );
        }

        // if we have a diff, find format parameters
        var higherLower = diff > 0 ? 'higher' : 'lower';

        var compareDirection = _this3.state.esg.direction === 'ascending' ? diff < 0 : diff > 0;

        var compareStyle = compareDirection ? 'positive' : 'negative';

        return _react2.default.createElement(
          'span',
          { styleName: compareStyle },
          _this3.renderEsgFormat(diff, true),
          '\xA0',
          higherLower
        );
      };

      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'annual-return-bottom-row' },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 5 },
          _react2.default.createElement(
            'strong',
            null,
            'Fund compared to benchmark'
          ),
          _react2.default.createElement('br', null),
          '\xA0'
        ),
        _this3.state.activeTimeHorizon ? _this3.state.returnDiffs.map(function (val, idx) {
          return _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { key: idx, xs: 1, styleName: 'col-center' },
            renderReturnComparison(val)
          );
        }) : _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 4, styleName: 'col-center' },
          _react2.default.createElement(NoReturnsAvailable, null)
        ),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 3, styleName: 'col-center' },
          renderTableEsgComparison()
        )
      );
    };

    var renderMorningstarTextLink = function renderMorningstarTextLink(shareClass) {
      var url = _this3.state.morningstarUrl;
      var ticker = shareClass.ticker || shareClass.fund_legal_name;
      return _react2.default.createElement(
        _components.Link,
        {
          to: url,
          xstrong: true,
          log: _analytics2.default.eventToMorningstar(shareClass.investment_vehicle_id),
          styleName: 'em'
        },
        'Find more financial data on ',
        ticker,
        ' at Morningstar.com',
        _react2.default.createElement(_components.LinkIcon, null)
      );
    };

    /*
    SlideDown layout
    */
    return _react2.default.createElement(
      'div',
      { styleName: 'returns-container' },
      _react2.default.createElement(
        'div',
        { styleName: 'explain-container-inner' },
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          { styleName: 'slide-down' },
          false ? null : _react2.default.createElement(
            'div',
            { styleName: 'slide-down-bg' },
            _react2.default.createElement(
              'div',
              { styleName: 'returns-table' },
              renderTableHeadlines(_shareClass),
              _react2.default.createElement(
                'div',
                { styleName: 'table-wrap hidden-xs' },
                renderTableHeaderRow(),
                _react2.default.createElement('div', { styleName: 'line' }),
                renderTableShareclassRow(_shareClass),
                _react2.default.createElement('div', { styleName: 'line' }),
                renderTableBenchmarkRow(),
                _react2.default.createElement('div', { styleName: 'line' }),
                renderTableComparisonRow()
              ),
              renderMorningstarTextLink(_shareClass)
            )
          )
        )
      )
    );
  };
}, _temp)) || _class2);
exports.default = Returns;


//////////////////
// WEBPACK FOOTER
// ./src/core/Returns/Returns.js
// module id = 1470
// module chunks = 0